import { useCallback, useMemo } from 'react';

import { useEmployerReactivationModalStore } from '@/modules/employer/components/EmployerReactivation/stores';

const EMPLOYER_CUSTOM_NAME = 'Employer';

export const useEmployerReactivationResume = () => {
  const employerName = useEmployerReactivationModalStore((state) => state.employerName);
  const handleChangeVisibility = useEmployerReactivationModalStore((state) => state.handleChangeVisibility);
  const handleResetModal = useEmployerReactivationModalStore((state) => state.handleReset);
  const additionalAction = useEmployerReactivationModalStore((state) => state.additionalAction);

  const displayName = useMemo(
    () => employerName || EMPLOYER_CUSTOM_NAME,
    [employerName]
  );

  const handleGotIt = useCallback(() => {
    handleChangeVisibility(false);
    handleResetModal();
    additionalAction?.();
  }, [handleChangeVisibility, handleResetModal, additionalAction]);

  return {
    employerName: displayName,
    handleGotIt,
  };
};
